import { EditOutlined, EyeOutlined, UploadOutlined } from '@ant-design/icons';
import { Trans } from '@lingui/macro';
import { Image, Spin } from 'antd';
import FileActions from 'bukku/redux/File/actions';
import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { UploadLightboxFileManagerContext } from '../context';
import LightboxActions from 'bukku/redux/Lightbox/actions';

const {
    readGlobalFiles,
} = FileActions;

const {
    // open: openLightbox,
    openForBukkuUpload: openLightboxForBukkuUpload,
} = LightboxActions;

export function ImageWithMask() {
    const { states, setStates, props } = useContext(UploadLightboxFileManagerContext);
    const {
        fileUrl,
        uploading,
        componentFile,
    } = states;
    const {
        setIsFileSelectVisible,
    } = setStates;
    const {
        // parent
        fileTypeFilter,
        disabled,
        openFileManagerOnClick,
    } = props;
    const dispatch = useDispatch();
    // Get url for uploaded file, or fallback to original file, or none.
    const imageUrl = fileUrl || null;

    const showModal = () => {
        if (!disabled) {
            dispatch(readGlobalFiles({
                page: 1,
                type: fileTypeFilter,
            }));
            setIsFileSelectVisible(true);
        }
    };

    const uploadButton = (
        <div className="upload-placeholder" {...openFileManagerOnClick && { onClick: showModal }}>
            <UploadOutlined />
            <div className="ant-upload-text"><Trans>Upload</Trans></div>
        </div>
    );

    // wrap with <div className='upload-img-container'> if want to open FileManager
    const ConditionalWrapper = ({ condition, wrapper, children }) => (condition ?
        wrapper(children) :
        children);

    const openLightboxOnClick = () => {
        // console.log('aaa openLigtbox', lightboxRef);
        // lightboxRef.current?.handleOnClick(e, 0);
        const shouldReadFile = !componentFile?.file.url && !imageUrl;
        const fileIdToRead = shouldReadFile ? componentFile?.file.id : null;
        dispatch(openLightboxForBukkuUpload(componentFile, imageUrl, fileIdToRead));
    };

    const renderImageMask = children => (
        <div className="upload-img-container">
            {/* // dark mask when hover ==> for viewing in lightGallery and edit via FileManager */}
            <div className="upload-img-mask">
                <EyeOutlined onClick={openLightboxOnClick} />
                <EditOutlined onClick={showModal} />
            </div>
            {children}
        </div>);

    if (disabled) {
        if (imageUrl) {
            return (
                <div className="upload-img-container disabled">
                    <Image
                        className="upload-img-image"
                        preview={false}
                        src={imageUrl}
                    />
                </div>
            );
        }
        return uploadButton;
    }
    return (
        <ConditionalWrapper
            condition={imageUrl && openFileManagerOnClick}
            wrapper={children => renderImageMask(children)}
        >
            <Spin spinning={uploading}>
                {imageUrl ?
                    <Image className="upload-img-image" preview={false} src={imageUrl} /> :
                    uploadButton}
            </Spin>
        </ConditionalWrapper>
    );
}
